/* ---------- Hero: the claim beside a tour stop ---------- */
.hero {
  /* Same overlap as the home hero: cancel the flow space the sticky header reserves. */
  margin-top: calc(-1 * (var(--header-h) + 2 * var(--header-margin)));
  padding-block: calc(var(--header-h) + 2 * var(--header-margin) + var(--sp-12)) var(--sp-20);
  background: var(--surface-alt);
}
.heroGrid {
  display: grid;
  gap: var(--sp-12);
  align-items: center;
}
.heroText > * {
  max-width: 40rem;
}
.heroTitle {
  /* Room under the breadcrumb, which the dropped eyebrow label used to provide. */
  margin-top: var(--sp-6);
  font-size: clamp(2.4rem, 3.4vw + 1rem, 4.25rem);
  line-height: 1.04;
  letter-spacing: -0.035em;
  text-wrap: balance;
}
.heroLead {
  margin-top: var(--sp-5);
  font-size: var(--fs-lg);
  color: var(--text);
}
.heroActions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--sp-4) var(--sp-8);
  margin-top: var(--sp-8);
}
.heroLink {
  font-weight: 600;
  color: var(--text-strong);
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 0.3em;
}
.heroLink:hover {
  color: var(--accent-text);
}
.heroNote {
  margin: var(--sp-6) 0 0;
  font-size: var(--fs-sm);
  color: var(--text-muted);
}
.heroMedia {
  position: relative;
}
.heroImage {
  border-radius: var(--radius-lg);
  box-shadow:
    0 0 0 1px var(--border),
    var(--shadow-lg);
}
/* One fact about the picture, pinned to it like a label. */
.heroChip {
  position: absolute;
  top: var(--sp-4);
  right: var(--sp-4);
  margin: 0;
  padding: var(--sp-2) var(--sp-3);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: var(--radius);
  background: rgba(8, 13, 19, 0.72);
  -webkit-backdrop-filter: blur(8px);
  backdrop-filter: blur(8px);
  color: #f5f7fa;
  font-size: var(--fs-sm);
  font-weight: 600;
}
@media (min-width: 64rem) {
  .heroGrid {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1.1fr);
    gap: var(--sp-16);
  }
}

/* ---------- How a tour reaches the public: three numbered steps ---------- */
.steps {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 16rem), 1fr));
  gap: var(--sp-8) var(--sp-10);
}
.steps li {
  padding-top: var(--sp-5);
  border-top: 1px solid var(--border-strong);
}
.stepNo {
  display: inline-grid;
  place-items: center;
  width: 2rem;
  height: 2rem;
  margin-bottom: var(--sp-4);
  border: 1px solid var(--accent);
  border-radius: 50%;
  font-weight: 700;
  color: var(--accent-text);
}
.steps h3 {
  margin-bottom: var(--sp-2);
  font-size: var(--fs-lg);
}
.steps p {
  margin: 0;
  color: var(--text);
}

/* ---------- The news report: its line beside the video ---------- */
.video {
  display: grid;
  gap: var(--sp-8);
  align-items: center;
}
.videoText p {
  margin: var(--sp-4) 0 var(--sp-5);
  font-size: var(--fs-md);
  color: var(--text);
}
@media (min-width: 64rem) {
  .video {
    grid-template-columns: minmax(0, 5fr) minmax(0, 7fr);
    gap: var(--sp-16);
  }
}
.news {
  position: relative;
  margin: 0;
}
.news :global(.video-embed) {
  box-shadow:
    0 0 0 1px var(--border),
    var(--shadow-lg);
}
/* The broadcast's banner already names the report, and the text beside it says the rest:
   no title over the picture (the button keeps its "Play video: ..." label), and only a
   soft shade behind the play button, so the frame stays bright. */
.news :global(.video-embed__title) {
  display: none;
}
.news :global(.video-embed__play) {
  background: radial-gradient(circle at 50% 50%, rgba(0, 0, 0, 0.35), transparent 45%);
}
/* Where the clip comes from, pinned to it like a label: top right, clear of the I-84
   project's logo in the broadcast's top left. */
.newsChip {
  position: absolute;
  top: var(--sp-4);
  right: var(--sp-4);
  margin: 0;
  padding: var(--sp-2) var(--sp-3);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: var(--radius);
  background: rgba(8, 13, 19, 0.72);
  -webkit-backdrop-filter: blur(8px);
  backdrop-filter: blur(8px);
  color: #f5f7fa;
  font-size: var(--fs-sm);
  font-weight: 600;
  pointer-events: none;
}
@media (max-width: 47.99rem) {
  .newsChip {
    top: var(--sp-2);
    right: var(--sp-2);
    padding: var(--sp-1) var(--sp-2);
    font-size: 0.75rem;
  }
}
